import { render, staticRenderFns } from "./ofertas.vue?vue&type=template&id=73cd8392&scoped=true"
import script from "./ofertas.vue?vue&type=script&lang=js"
export * from "./ofertas.vue?vue&type=script&lang=js"
import style0 from "./ofertas.vue?vue&type=style&index=0&id=73cd8392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cd8392",
  null
  
)

export default component.exports